export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_03.a7b18405.mp4";